import ConfirmDelete from './ConfirmDelete';

export default ConfirmDelete;
